import React from "react";
import BaseCarTypeFilter from "./baseCarType";

const TrailerTypeFilter = (props) => {
    const selectProps = {
        inputProps: { name: "trailerTypeId" },
        value: props.values.trailerTypeId,
        setValue: props.setFilter,
        placeholder: "Тип прицепа",
        options: props.enums.trailerType,
        ...props.selectProps,
    };
    return <BaseCarTypeFilter {...props} selectProps={selectProps} />;
};

export default TrailerTypeFilter;
